<template>
  <UserShell
    title="个人中心"
    subtitle="查看个人资料与申请记录"
    :profile="profile"
    :menu-items="menuItems"
    active-key="profile"
    center-path="/user/personal"
  >
    <div class="hero-row">
      <button type="button" class="hero-avatar-btn" @click="triggerAvatarUpload">
        <img class="hero-avatar" :src="profile.avatar" alt="头像" referrerpolicy="no-referrer" />
        <div class="hero-avatar-mask">
          <img class="hero-avatar-mask-icon" :src="avatarMaskIcon" alt="替换图片" />
          <span>替换图片</span>
        </div>
      </button>
      <input ref="avatarUploader" type="file" class="hidden-input" accept=".jpg,.jpeg,.png" @change="handleAvatarChange" />
      <div class="hero-meta">
        <div class="hero-name-row">
          <div class="hero-name">{{ profile.name }}</div>
          <img class="hero-tag" :src="personalTag" alt="个人主播" />
        </div>
        <div class="hero-subline">平台ID：{{ basicInfo.platformId }} | 注册时间：{{ basicInfo.registerDate }}</div>
      </div>
    </div>
    <div class="info-strip card-soft">
        <div v-for="(item, index) in quickInfo" :key="item.label" class="info-cell">
        <div class="info-label">
          {{ item.label }}
          
        </div>
        <div class="info-value" :class="index === 2 ? 'info-value-highlight' : ''">{{ item.value }}
          <button v-if="index === 0 && !isCertificationLocked" type="button" class="edit-name-btn" title="修改主播姓名" @click="openNameDialog">
            <img class="edit-name-icon" :src="xgImage" alt="修改主播姓名" />
          </button></div>
      </div>
    </div>

    <el-dialog title="修改主播姓名" :visible.sync="nameDialogVisible" width="420px" :close-on-click-modal="false" @closed="resetNameDialog">
      <el-form label-width="88px">
        <el-form-item label="主播姓名：">
          <el-input v-model.trim="nameForm.name" maxlength="100" show-word-limit placeholder="请输入主播姓名" @keyup.enter.native="submitName" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="nameDialogVisible = false">取消</el-button>
        <el-button type="primary" class="qd" :loading="isSubmittingName" @click="submitName">确定</el-button>
      </div>
    </el-dialog>

    <section class="section-block">
      <div class="section-heading">
        <img class="section-icon" :src="authIcon" alt="身份认证" />
        <span>身份认证</span>
      </div>

      <div class="field-title">身份证照片 <span class="required">*</span></div>
      <div class="field-title-desc">1.请上传信息清晰可见的证件照片，支持jpg、png、jpeg 格式的图片，大小不能大于5M</div>
      <div class="upload-row">
        <button type="button" class="upload-card" @click="pickFile('front')">
          <img :src="idFrontPreview" alt="身份证正面" referrerpolicy="no-referrer" />
        </button>
        <button type="button" class="upload-card" @click="pickFile('back')">
          <img :src="idBackPreview" alt="身份证背面" referrerpolicy="no-referrer" />
        </button>
      </div>
      <input ref="frontUploader" type="file" class="hidden-input" accept=".jpg,.jpeg,.png" @change="handleIdFileChange('front', $event)" />
      <input ref="backUploader" type="file" class="hidden-input" accept=".jpg,.jpeg,.png" @change="handleIdFileChange('back', $event)" />

      <div class="field-title top-space">身份证号 <span class="required">*</span></div>
      <div class="identity-row">
        <el-input v-model.trim="identityNo" :disabled="isCertificationLocked" :placeholder="identityInputPlaceholder" class="identity-input" />
      </div>
      <div class="field-title-desc">当前认证状态：{{ certificationStatusText }}</div>

      <button type="button" class="primary-mini" :disabled="isSubmittingIdentity || isCertificationLocked" @click="submitIdentity">{{ submitButtonText }}</button>
    </section>

    <section class="section-block materials-block">
      <div class="materials-header">
        <div class="section-heading small-gap">
          <img class="section-icon" :src="materialIcon" alt="我的资料" />
          <span>我的资料</span>
        </div>
        <button type="button" class="add-btn" @click="openAddPlatformDialog">新增平台</button>
      </div>

      <div v-if="platformCards.length" class="platform-grid">
        <article v-for="item in platformCards" :key="item.id" class="platform-card card-soft">
          <div class="platform-head">
            <div class="platform-title">
              <img v-if="getPlatformLogo(item.platform || item.platformLabel)" class="platform-logo" :src="getPlatformLogo(item.platform || item.platformLabel)" :alt="item.platformLabel" />
              <span v-else class="platform-logo-fallback">{{ getPlatformShortName(item.platform || item.platformLabel) }}</span>
              <span>{{ item.platformLabel }}</span>
            </div>
          </div>

          <div v-if="editingId === item.id" class="platform-body editing-body">
            <div class="platform-row editor-row">
              <span>主播平台</span>
              <el-select v-model="editingForm.platform" placeholder="请选择平台" class="platform-inline-select">
                <el-option v-for="option in platformOptions" :key="option.value" :label="option.label" :value="option.value" />
              </el-select>
            </div>
            <div class="platform-row editor-row">
              <span>主播昵称</span>
              <el-input v-model.trim="editingForm.name" placeholder="请输入主播昵称" class="platform-inline-input" />
            </div>
            <div class="platform-row editor-row">
              <span>粉丝数量</span>
              <el-input v-model.trim="editingForm.fans" placeholder="请输入粉丝数量" class="platform-inline-input fans" />
            </div>
            <div class="platform-row editor-row">
              <span>垂类赛道</span>
              <el-select v-model="editingForm.category" placeholder="请选择垂类赛道" class="platform-inline-select">
                <el-option v-for="option in categoryOptions" :key="option.value" :label="option.label" :value="option.value" />
              </el-select>
            </div>
            <div class="platform-row editor-row">
              <span>平台ID号</span>
              <el-input v-model.trim="editingForm.accountId" placeholder="请输入平台ID号" class="platform-inline-input" />
            </div>
          </div>

          <div v-else class="platform-body">
            <div class="platform-row"><span>主播昵称</span><strong>{{ item.name || '--' }}</strong></div>
            <div class="platform-row"><span>粉丝数量</span><strong class="fans">{{ item.fans || '--' }}</strong></div>
            <div class="platform-row"><span>垂类赛道</span><strong>{{ item.categoryLabel }}</strong></div>
            <div class="platform-row"><span>平台ID号</span><strong>{{ item.accountId || '--' }}</strong></div>
          </div>

          <div class="platform-actions">
            <template v-if="editingId === item.id">
              <button type="button" class="action-btn primary" @click="savePlatform(item)">保存</button>
              <button type="button" class="action-btn" @click="cancelEditPlatform">取消</button>
            </template>
            <template v-else>
              <button type="button" class="action-btn primary" @click="startEditPlatform(item)">修改</button>
              <button type="button" class="action-btn" @click="removePlatform(item)">删除</button>
            </template>
          </div>
        </article>
      </div>
      <div v-else class="empty-state card-soft">暂无平台资料</div>

      <el-dialog
        title="新增平台"
        :visible.sync="platformDialogVisible"
        width="520px"
        :close-on-click-modal="false"
        @closed="resetPlatformDialog"
      >
        <el-form ref="platformForm" :model="platformForm" :rules="platformRules" label-width="96px" class="platform-form">
          <el-form-item label="主播平台" prop="platform">
            <el-select v-model="platformForm.platform" placeholder="请选择平台" class="dialog-control">
              <el-option v-for="option in platformOptions" :key="option.value" :label="option.label" :value="option.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="主播昵称" prop="name">
            <el-input v-model.trim="platformForm.name" placeholder="请输入主播昵称" class="dialog-control" />
          </el-form-item>
          <el-form-item label="粉丝数量" prop="fans">
            <el-input v-model.trim="platformForm.fans" placeholder="请输入粉丝数量" class="dialog-control" />
          </el-form-item>
          <el-form-item label="垂类赛道" prop="category">
            <el-select v-model="platformForm.category" placeholder="请选择垂类赛道" class="dialog-control">
              <el-option v-for="option in categoryOptions" :key="option.value" :label="option.label" :value="option.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="平台ID号" prop="accountId">
            <el-input v-model.trim="platformForm.accountId" placeholder="请输入平台ID号" class="dialog-control" />
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="platformDialogVisible = false">取消</el-button>
          <el-button type="primary" class="qd" @click="submitPlatform">确定</el-button>
        </div>
      </el-dialog>
    </section>
  </UserShell>
</template>

<script>
import UserShell from './components/UserShell.vue';
import authIcon from '@/assets/img/user/认证icon.png';
import materialIcon from '@/assets/img/user/资料icon.png';
import avatarMaskIcon from '@/assets/img/user/bj.png';
import idFrontImage from '@/assets/img/user/身份证正面.png';
import idBackImage from '@/assets/img/user/身份证背面.png';
import xgImage from '@/assets/img/user/xg.png';
import {
  createMemberPlatformAccount,
  deleteMemberPlatformAccount,
  getMemberCertification,
  getMemberProfile,
  submitIndividualCertification,
  updateMemberAvatar,
  updateMemberName,
  updateMemberPlatformAccount,
  uploadMemberImage,
  verifyMemberIdCard
} from '@/api/user';
import {
  createEmptyPlatformForm,
  createPersonalMenu,
  getPlatformShortName,
  personalBasicInfo,
  personalMenuAssets,
  personalProfile,
  personalQuickInfo
} from './personalShared';
import { updateCachedUserInfo } from '@/utils/userInfo';

const MAX_IMAGE_SIZE = 5 * 1024 * 1024;
const PLATFORM_OPTIONS = [
  { value: 'douyin', label: '抖音' },
  { value: 'kuaishou', label: '快手' },
  { value: 'bilibili', label: 'B站' },
  { value: 'xiaohongshu', label: '小红书' },
  { value: 'weibo', label: '微博' },
  { value: 'wechat_video', label: '微信视频号' }
];
const VERTICAL_TRACK_OPTIONS = [
  { value: 'beauty_care', label: '美妆护肤' },
  { value: 'fashion_apparel', label: '服饰穿搭' },
  { value: 'food_beverage', label: '食品饮料' },
  { value: 'digital', label: '3C数码' },
  { value: 'home_living', label: '家居生活' },
  { value: 'maternity_child', label: '母婴育儿' },
  { value: 'education', label: '教育知识' },
  { value: 'sports_outdoors', label: '运动户外' },
  { value: 'gaming', label: '游戏电竞' }
];
const PLATFORM_LABEL_MAP = PLATFORM_OPTIONS.reduce((accumulator, item) => {
  accumulator[item.value] = item.label;
  return accumulator;
}, {});
const VERTICAL_TRACK_LABEL_MAP = VERTICAL_TRACK_OPTIONS.reduce((accumulator, item) => {
  accumulator[item.value] = item.label;
  return accumulator;
}, {});

function formatDate(value) {
  if (!value) {
    return '--';
  }

  return String(value).replace(/-/g, '.');
}

function getUserTypeText(type, fallback) {
  if (fallback) {
    return fallback;
  }

  if (type === 'individual') {
    return '个人';
  }

  return type || '--';
}

function normalizePlatformAccount(item, index) {
  const source = item && typeof item === 'object' ? item : {};
  const platformValue = source.platform || '';
  const verticalTrackValue = source.vertical_track || source.category || '';

  return {
    id: source.id || `platform-${index}`,
    platform: platformValue,
    platformLabel: source.platform_text || PLATFORM_LABEL_MAP[platformValue] || source.platform_name || '--',
    name: source.nickname || source.name || source.account_name || '',
    fans: source.fans_count || source.fans || source.followers_count || '',
    category: verticalTrackValue,
    categoryLabel: source.vertical_track_text || source.category_name || source.track || VERTICAL_TRACK_LABEL_MAP[verticalTrackValue] || '--',
    accountId: source.platform_id || source.account_id || source.account_no || source.platform_account_id || ''
  };
}

function extractUploadUrl(response) {
  const data = response && typeof response === 'object' && Object.prototype.hasOwnProperty.call(response, 'data')
    ? response.data
    : response;

  if (typeof data === 'string') {
    return data;
  }

  if (!data || typeof data !== 'object') {
    return '';
  }

  return data.url || data.full_url || data.path || data.location || '';
}

function getCertificationStatusLabel(status) {
  if (status === 'pending') {
    return '待审核';
  }
  if (status === 'approved') {
    return '已通过';
  }
  if (status === 'rejected') {
    return '已驳回';
  }
  return '未认证';
}

function syncCachedUserInfo(profileData, certificationData) {
  try {
    const raw = window.localStorage.getItem('userInfo');
    const cachedUserInfo = raw ? JSON.parse(raw) : {};
    const platformAccounts = Array.isArray(profileData.platform_accounts)
      ? profileData.platform_accounts
      : (Array.isArray(cachedUserInfo.platform_accounts) ? cachedUserInfo.platform_accounts : []);
    const nextUserInfo = {
      ...cachedUserInfo,
      avatar: profileData.avatar || '',
      name: profileData.name || '',
      type: profileData.type || '',
      type_text: profileData.type_text+'主播'|| '',
      phone: profileData.phone || '',
      created_at: profileData.created_at || '',
      account_no: profileData.account_no || '',
      id_card_no: certificationData.id_card_no || cachedUserInfo.id_card_no || '',
      platform_accounts: platformAccounts
    };
    updateCachedUserInfo(nextUserInfo);
  } catch (error) {
    void error;
  }
}

function getCachedPlatformCards() {
  try {
    const raw = window.localStorage.getItem('userInfo');
    const cachedUserInfo = raw ? JSON.parse(raw) : {};
    const platformAccounts = Array.isArray(cachedUserInfo.platform_accounts)
      ? cachedUserInfo.platform_accounts
      : [];

    return platformAccounts.map((item, index) => normalizePlatformAccount(item, index));
  } catch (error) {
    return [];
  }
}

export default {
  name: 'PersonalCenter',
  components: { UserShell },
  computed: {
    isCertificationLocked() {
      return this.certificationStatus === 'pending' || this.certificationStatus === 'approved';
    },
    certificationStatusText() {
      return this.certificationStatusTextValue || getCertificationStatusLabel(this.certificationStatus);
    },
    identityInputPlaceholder() {
      return this.isCertificationLocked ? '' : '请输入身份证号码';
    },
    submitButtonText() {
      if (this.certificationStatus === 'approved') {
        return '已认证';
      }
      if (this.certificationStatus === 'pending') {
        return '待审核';
      }
      if (this.isSubmittingIdentity) {
        return '提交中...';
      }
      if (this.certificationStatus === 'rejected') {
        return '重新提交';
      }
      return '提交';
    }
  },
  data() {
    return {
      authIcon,
	  xgImage,
      materialIcon,
      avatarMaskIcon,
      personalTag: personalMenuAssets.personalTag,
      idFrontPreview: idFrontImage,
      idBackPreview: idBackImage,
      idCardFrontUrl: '',
      idCardBackUrl: '',
      identityNo: '',
      certificationStatus: '',
      certificationStatusTextValue: '',
       certifiedIdCardNo: '',
       isSubmittingIdentity: false,
       nameDialogVisible: false,
       isSubmittingName: false,
       nameForm: { name: '' },
       editingId: null,
      editingForm: createEmptyPlatformForm(),
      platformDialogVisible: false,
      platformActionsEnabled: true,
      platformForm: createEmptyPlatformForm(),
      platformOptions: PLATFORM_OPTIONS,
      categoryOptions: VERTICAL_TRACK_OPTIONS,
      platformLogoMap: personalMenuAssets.platformLogoMap,
      profile: { ...personalProfile },
      basicInfo: { ...personalBasicInfo },
      menuItems: createPersonalMenu(),
      quickInfo: personalQuickInfo.map(item => ({ ...item })),
      platformCards: getCachedPlatformCards(),
      platformRules: {
        platform: [{ required: true, message: '请选择主播平台', trigger: 'change' }],
        category: [{ required: true, message: '请选择垂类赛道', trigger: 'change' }]
      }
    };
  },
  created() {
    this.fetchPersonalData();
  },
  methods: {
    async fetchPersonalData() {
      try {
        const [certificationResponse, profileResponse] = await Promise.all([
          getMemberCertification(),
          getMemberProfile()
        ]);
        this.applyPersonalData(
          certificationResponse && certificationResponse.data ? certificationResponse.data : {},
          profileResponse && profileResponse.data ? profileResponse.data : {}
        );
      } catch (error) {
        if (error && error.isAuthExpired) {
          return;
        }
        this.$message.error(error && error.message ? error.message : '获取个人中心信息失败');
      }
    },
    applyPersonalData(certificationData, profileData) {
      const typeText = getUserTypeText(profileData.type, profileData.type_text);
      const avatar = profileData.avatar || this.profile.avatar || personalProfile.avatar;
      const certificationStatus = certificationData.status || '';
      const certificationStatusText = certificationData.status_text || '';
      const certifiedIdCardNo = certificationData.id_card_no || '';
      const idCardFrontUrl = certificationData.id_card_front || '';
      const idCardBackUrl = certificationData.id_card_back || '';

      this.certificationStatus = certificationStatus;
      this.certificationStatusTextValue = certificationStatusText;
      this.certifiedIdCardNo = certifiedIdCardNo;
      this.idCardFrontUrl = idCardFrontUrl;
      this.idCardBackUrl = idCardBackUrl;
      this.idFrontPreview = idCardFrontUrl || idFrontImage;
      this.idBackPreview = idCardBackUrl || idBackImage;
      this.profile = {
        ...this.profile,
        name: profileData.name || personalProfile.name,
        role: typeText,
        avatar
      };
      this.basicInfo = {
        ...this.basicInfo,
        platformId: profileData.account_no || '--',
        registerDate: formatDate(profileData.created_at)
      };
      this.identityNo = this.isCertificationLocked ? certifiedIdCardNo : '';
      this.quickInfo = [
        { label: '姓名', value: profileData.name || '--' },
        { label: '手机号', value: profileData.phone || '--' },
        { label: '身份类型', value: typeText+'主播' },
        { label: '身份证号', value: certifiedIdCardNo || '未认证' }
      ];
      this.platformCards = Array.isArray(profileData.platform_accounts)
        ? profileData.platform_accounts.map((item, index) => normalizePlatformAccount(item, index))
        : [];
      syncCachedUserInfo(profileData, certificationData);
    },
    async refreshMemberProfile() {
      const profileResponse = await getMemberProfile();
      this.applyPersonalData(
        {
          status: this.certificationStatus,
          status_text: this.certificationStatusTextValue,
          id_card_no: this.certifiedIdCardNo,
          id_card_front: this.idCardFrontUrl,
          id_card_back: this.idCardBackUrl
        },
        profileResponse && profileResponse.data ? profileResponse.data : {}
      );
    },
    openNameDialog() {
      if (this.isCertificationLocked) {
        return;
      }
      this.nameForm = { name: this.profile.name || '' };
      this.nameDialogVisible = true;
    },
    resetNameDialog() {
      this.nameForm = { name: '' };
    },
    async submitName() {
      const name = this.nameForm.name.trim();
      if (!name) {
        this.$message.warning('请输入主播姓名');
        return;
      }

      this.isSubmittingName = true;
      try {
        await updateMemberName({ name });
        this.nameDialogVisible = false;
        this.$message.success('主播姓名已更新');
        await this.refreshMemberProfile();
      } catch (error) {
        this.$message.error(error && error.message ? error.message : '主播姓名更新失败');
      } finally {
        this.isSubmittingName = false;
      }
    },
    triggerAvatarUpload() {
      const input = this.$refs.avatarUploader;
      if (input) {
        input.click();
      }
    },
    async handleAvatarChange(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }

      if (file.size > MAX_IMAGE_SIZE) {
        this.$message.warning('图片大小不能超过5M');
        event.target.value = '';
        return;
      }

      try {
        const uploadResponse = await uploadMemberImage(file);
        const avatarUrl = extractUploadUrl(uploadResponse);
        if (!avatarUrl) {
          throw new Error('上传成功但未获取到头像地址');
        }

        await updateMemberAvatar({ avatar: avatarUrl });
        this.profile = {
          ...this.profile,
          avatar: avatarUrl
        };
        updateCachedUserInfo({ avatar: avatarUrl });
        this.$message.success('头像已更新');
      } catch (error) {
        this.$message.error(error && error.message ? error.message : '头像更新失败');
      } finally {
        event.target.value = '';
      }
    },
    pickFile(type) {
      if (this.isCertificationLocked) {
        this.$message.warning(`当前认证状态为${this.certificationStatusText}`);
        return;
      }

      const refName = type === 'front' ? 'frontUploader' : 'backUploader';
      const input = this.$refs[refName];
      if (input) {
        input.click();
      }
    },
    async handleIdFileChange(type, event) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }

      if (file.size > MAX_IMAGE_SIZE) {
        this.$message.warning('图片大小不能超过5M');
        event.target.value = '';
        return;
      }

      try {
        const uploadResponse = await uploadMemberImage(file);
        const uploadUrl = extractUploadUrl(uploadResponse);
        if (!uploadUrl) {
          throw new Error('上传成功但未获取到图片地址');
        }

        const previewUrl = await this.readFileAsDataUrl(file);
        if (type === 'front') {
          this.idCardFrontUrl = uploadUrl;
          this.idFrontPreview = previewUrl;
        } else {
          this.idCardBackUrl = uploadUrl;
          this.idBackPreview = previewUrl;
        }
        this.$message.success('图片上传成功');
      } catch (error) {
        this.$message.error(error && error.message ? error.message : '图片上传失败');
      } finally {
        event.target.value = '';
      }
    },
    readFileAsDataUrl(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = loadEvent => {
          const result = loadEvent && loadEvent.target ? loadEvent.target.result : '';
          resolve(result ? String(result) : '');
        };
        reader.onerror = () => reject(new Error('图片预览生成失败'));
        reader.readAsDataURL(file);
      });
    },
    validateIdentityForm() {
      if (!this.idCardFrontUrl) {
        this.$message.warning('请上传身份证正面照片');
        return false;
      }
      if (!this.idCardBackUrl) {
        this.$message.warning('请上传身份证反面照片');
        return false;
      }
      if (!this.identityNo) {
        this.$message.warning('请输入身份证号码');
        return false;
      }
      if (!/(^\d{15}$)|(^\d{17}[\dXx]$)/.test(this.identityNo)) {
        this.$message.warning('请输入正确的身份证号码');
        return false;
      }
      return true;
    },
    async submitIdentity() {
      if (this.isCertificationLocked) {
        this.$message.warning(`当前认证状态为${this.certificationStatusText}`);
        return;
      }
      if (!this.validateIdentityForm()) {
        return;
      }

      this.isSubmittingIdentity = true;
      try {
        await verifyMemberIdCard({ id_card_no: this.identityNo });
        await submitIndividualCertification({
          id_card_no: this.identityNo,
          id_card_front: this.idCardFrontUrl,
          id_card_back: this.idCardBackUrl
        });
        this.$message.success('认证信息已提交');
        await this.fetchPersonalData();
      } catch (error) {
        this.$message.error(error && error.message ? error.message : '认证提交失败');
      } finally {
        this.isSubmittingIdentity = false;
      }
    },
    getPlatformLogo(platform) {
      return this.platformLogoMap[PLATFORM_LABEL_MAP[platform] || platform] || '';
    },
    getPlatformShortName(platform) {
      return getPlatformShortName(PLATFORM_LABEL_MAP[platform] || platform);
    },
    buildPlatformPayload(form) {
      return {
        platform: form.platform,
        vertical_track: form.category,
        platform_id: form.accountId || '',
        fans_count: form.fans || '',
        nickname: form.name || ''
      };
    },
    validatePlatformDraft(form) {
      if (!form.platform) {
        this.$message.warning('请选择主播平台');
        return false;
      }
      if (!form.category) {
        this.$message.warning('请选择垂类赛道');
        return false;
      }
      if (form.accountId && form.accountId.length > 100) {
        this.$message.warning('平台ID不能超过100个字符');
        return false;
      }
      if (form.fans && form.fans.length > 50) {
        this.$message.warning('粉丝数量不能超过50个字符');
        return false;
      }
      if (form.name && form.name.length > 100) {
        this.$message.warning('主播昵称不能超过100个字符');
        return false;
      }
      return true;
    },
    openAddPlatformDialog() {
      if (this.editingId !== null) {
        this.$message.warning('请先保存或取消当前编辑内容');
        return;
      }
      this.platformDialogVisible = true;
      this.platformForm = createEmptyPlatformForm();
      this.$nextTick(() => {
        if (this.$refs.platformForm) {
          this.$refs.platformForm.clearValidate();
        }
      });
    },
    resetPlatformDialog() {
      this.platformForm = createEmptyPlatformForm();
      if (this.$refs.platformForm) {
        this.$refs.platformForm.resetFields();
      }
    },
    submitPlatform() {
      this.$refs.platformForm.validate(async valid => {
        if (!valid) {
          return;
        }
        if (!this.validatePlatformDraft(this.platformForm)) {
          return;
        }
        try {
          await createMemberPlatformAccount(this.buildPlatformPayload(this.platformForm));
          this.platformDialogVisible = false;
          this.$message.success('平台已新增');
          await this.refreshMemberProfile();
        } catch (error) {
          this.$message.error(error && error.message ? error.message : '新增平台失败');
        }
      });
    },
    startEditPlatform(item) {
      if (this.editingId !== null && this.editingId !== item.id) {
        this.$message.warning('请先保存或取消当前编辑内容');
        return;
      }
      this.editingId = item.id;
      this.editingForm = {
        platform: item.platform,
        name: item.name,
        fans: item.fans,
        category: item.category,
        accountId: item.accountId
      };
    },
    cancelEditPlatform() {
      this.editingId = null;
      this.editingForm = createEmptyPlatformForm();
    },
    async savePlatform(item) {
      if (!this.validatePlatformDraft(this.editingForm)) {
        return;
      }
      try {
        await updateMemberPlatformAccount(item.id, this.buildPlatformPayload(this.editingForm));
        this.cancelEditPlatform();
        this.$message.success('平台资料已保存');
        await this.refreshMemberProfile();
      } catch (error) {
        this.$message.error(error && error.message ? error.message : '平台资料保存失败');
      }
    },
    async removePlatform(item) {
      if (this.editingId === item.id) {
        this.cancelEditPlatform();
      }
      try {
        await deleteMemberPlatformAccount(item.id);
        this.platformCards = this.platformCards.filter(card => card.id !== item.id);
        this.$message.success('已删除');
      } catch (error) {
        this.$message.error(error && error.message ? error.message : '删除失败');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.hero-row {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 28px;
  padding-bottom: 26px;
  border-bottom: 1px solid #e6e8ee;
}

.hero-avatar-btn {
  position: relative;
  width: 74px;
  height: 74px;
  border: 0;
  padding: 0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  overflow: hidden;
}

.hero-avatar {
  width: 74px;
  height: 74px;
  display: block;
  border-radius: 50%;
  object-fit: cover;
  background: conic-gradient(from 0deg, #9f64ff, #528aff);
  padding: 2px;
  box-sizing: border-box;
  position: relative;
}

.hero-avatar-mask {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 50%;
  background: rgba(15, 23, 42, 0.58);
  color: #fff;
  font-size: 12px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.hero-avatar-btn:hover .hero-avatar-mask {
  opacity: 1;
}

.hero-avatar-mask-icon {
  width: 16px;
  height: 16px;
}

.hero-name-row {
  display: flex;
  align-items: center;
  gap: 20px;
}

.hero-name {
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 500;
  font-size: 22px;
  color: #1e293b;
}

.hero-tag {
  width: 82px;
  height: 28px;
}

.hero-subline {
  margin-top: 8px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 14px;
  color: #84899e;
}

.card-soft {
  background: #f8f9fc;
  border-radius: 10px;
}

.info-strip {
  width: 796px;
  max-width: 100%;
  min-height: 78px;
  margin-top: 20px;
  padding: 18px 22px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
}

.info-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 400;
  font-size: 12px;
  color: #999fb8;
  line-height: 20px;
  text-align: left;
}

.edit-name-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.edit-name-icon {
  display: block;
  width: 14px;
  height: 14px;
  object-fit: contain;
}

.info-value {
  margin-top: 8px;
  font-weight: 400;
  font-size: 14px;
  color: #1e293b;
  text-align: left;
  display: flex;
  align-items: center;
}

.info-value-highlight {
  color: #636af0;
}

.section-block {
  margin-top: 32px;
}

.materials-block {
  margin-top: 37px;
  padding-top: 34px;
  border-top: 1px solid #e6e8ee;
}

.section-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 600;
  font-size: 16px;
  color: #1e293b;
}

.small-gap {
  gap: 8px;
}

.section-icon {
  width: 18px;
  height: 18px;
}

.field-title {
  margin-top: 20px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 600;
  font-size: 14px;
  color: #1e293b;
  line-height: 22px;
}

.field-title-desc {
  max-width: 551px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 14px;
  color: #999fb8;
  margin-top: 4px;
  line-height: 22px;
}

.required {
  color: #f26666;
}

.upload-row {
  display: flex;
  gap: 22px;
  margin-top: 10px;
}

.upload-card {
  width: 126px;
  height: 102px;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
}

.upload-card img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.top-space {
  margin-top: 20px;
}

.identity-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 14px;
}

.identity-input {
  width: 400px;
}

.identity-input ::v-deep .el-input__inner {
  width: 440px;
  max-width: 100%;
  height: 45px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.primary-mini,
.add-btn,
.action-btn {
  border: 0;
  cursor: pointer;
}

.primary-mini,
.add-btn,
.action-btn.primary {
  background: #6f68f3;
  color: #fff;
}

.primary-mini:disabled,
.add-btn:disabled,
.action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.primary-mini {
  width: 74px;
  height: 34px;
  border-radius: 8px;
  margin-top: 20px;
}

.materials-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-btn {
  width: 88px;
  height: 30px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
}

.platform-grid {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.empty-state {
  margin-top: 18px;
  padding: 24px;
  color: #84899e;
  font-size: 14px;
}

.platform-card {
  padding: 22px 21px;
  width: 256px;
  min-height: 272px;
  background: #F8F9FC;
  border-radius: 10px 10px 10px 10px;
}

.platform-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 16px;
  color: #1E293B;
}

.platform-logo {
  width: 28px;
  height: 28px;
}

.platform-logo-fallback {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #7b8cff 0%, #6f68f3 100%);
  color: #fff;
  font-size: 14px;
  line-height: 28px;
  text-align: center;
}

.platform-body {
  margin-top: 18px;
}

.platform-row {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  margin-top: 20px;
  font-weight: 400;
  font-size: 14px;
  color: #999fb8;
}

.platform-row strong {
  font-weight: 400;
  font-size: 14px;
  color: #1E293B;
}
.fans{
	color: #636AF0 !important;
}

.fans ::v-deep .el-input__inner{
	color: #636AF0 !important;
}
.editing-body {
  margin-top: 14px;
}

.editor-row {
  align-items: center;
}

.editor-row span {
  flex: 0 0 72px;
}

.platform-inline-input,
.platform-inline-select {
  width: calc(100% - 86px);
}

.platform-inline-input ::v-deep .el-input__inner,
.platform-inline-select ::v-deep .el-input__inner {
  height: 34px;
  border-radius: 8px;
  border: 1px solid #d9deef;
  background: #fff;
}

.platform-actions {
  display: flex;
  gap: 10px;
  margin-top: 22px;
}

.action-btn {
  min-width: 62px;
  height: 32px;
  padding: 0 14px;
  border-radius: 8px;
  background: #fff;
  color: #7f86a7;
  border: 1px solid #d8dfef;
}

.platform-form ::v-deep .el-form-item__label {
  color: #475569;
  margin-top: 14px;
}

.dialog-control {
  width: 100%;
}
.dialog-control ::v-deep .el-input__inner{
	width: 100% !important;
}


.dialog-footer {
  text-align: right;
}

.hidden-input {
  display: none;
}

.qd{
	background: #6f68f3;
}
@media (max-width: 1200px) {
  .info-strip,
  .platform-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 760px) {
  .hero-row,
  .identity-row,
  .materials-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .info-strip,
  .platform-grid {
    grid-template-columns: 1fr;
  }

  .upload-row {
    flex-wrap: wrap;
  }

  .identity-input,
  .identity-input ::v-deep .el-input__inner,
  .platform-inline-input,
  .platform-inline-select {
    width: 100%;
  }

  .editor-row {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
